import React from 'react'
import { RedSolidExclamationIcon } from '../../../../../Component/Icons'

interface Props {
  message: string
  subMessage?: string
}

export function MaxLineItemErrorRow (props: Props): React.JSX.Element {
  const {
    message,
    subMessage = 'Please adjust the data accordingly.',
  } = props

  return (
    <tr className="ed-max-line-item-error-row">
      <td colSpan={6}>
        <div className="ed-error-banner">
          <div className="ed-error-icon-wrapper">
            <RedSolidExclamationIcon />
          </div>
          <div className="ed-error-content">
            <p className="ed-error-title">{message}</p>
            {subMessage && <p className="ed-error-sub-message">{subMessage}</p>}
          </div>
        </div>
      </td>
    </tr>
  )
}
